import teamConfig from "../../../utils/constants/teams";

const { salesManager } = teamConfig.teams;

export const drawerItemsMain = (usersTeam: string, isAdminOrOwner: boolean) => [
  {
    key: "Stocks",
    title: "stock",
    routes: [{ nav: "Stocks", routeName: "Stocks", title: "stock" }],
  },
  {
    key: "Products",
    title: "searchProduct",
    routes: [{ nav: "Products", routeName: "Products", title: "product" }],
  },
  {
    key: "CustomerStatus",
    title: "customerStatus",
    routes: [
      {
        nav: "CustomerStatus",
        routeName: "CustomerStatus",
        title: "customerStatus",
      },
    ],
  },
  // {
  //   key: "CustomerOrder",
  //   title: "Customer Order",
  //   routes: [{ nav: "CustomerOder", routeName: "CustomerOrder", title: "Customer Order" }],
  // },
  ...(usersTeam === salesManager || isAdminOrOwner
    ? [
        {
          key: "SalesScorecard",
          title: "Sales Scorecard",
          routes: [
            {
              nav: "SalesScorecard",
              routeName: "SalesScorecard",
              title: "Dashboard",
            },
            {
              nav: "UsageSalesScorecard",
              routeName: "UsageSalesScorecard",
              title: "Usage",
            },
            {
              nav: "ValueSalesScorecard",
              routeName: "ValueSalesScorecard",
              title: "Value",
            },
            {
              nav: "InvoiceDNDetail",
              routeName: "InvoiceDNDetail",
              title: "Invoice & DN ",
            },
          ],
        },
      ]
    : []),
];
